import {LicenseDetails} from '../../model/license/license-details.model';
import {LicenseFeatureDetails} from '../../model/license/license-feature-details.model';
import {LicenseOrganizationModel} from '../../model/license/license-organization.model';
import {GrantLogEntry} from '../../model/license/grant-log-entry.model';
import axios from '../axios';

export namespace LicenseOrganizationController {
  export const queryFeatureTemplates = async (organizationIds: string[]) =>
    (await axios.put<LicenseOrganizationModel[]>('/internal/license/group', {groupIds: organizationIds})).data

  // Tworzenie PUSTEJ licencji: typ konta pod umowe (LicenseType), waznosc i reczny rabat (%).
  // Ficzery organizacja dobiera sama pozniej (grant).
  export type CreateOrganizationLicenseRequest = {
    licenseType: string
    licenseExpiredDate: string
    discount: number
  }

  export const createOrganizationLicense = async (organizationId: string, organizationName: string, request: CreateOrganizationLicenseRequest) =>
    (await axios.post(`/internal/license/group/${organizationId}?groupName=${organizationName}`, request))

  // Edycja metadanych licencji: typ konta, reczny rabat, data waznosci.
  export type UpdateOrganizationLicenseRequest = {
    licenseType: string
    discount: number
    licenseExpiredDate: string
  }

  export const updateOrganizationLicense = async (organizationId: string, request: UpdateOrganizationLicenseRequest) =>
    (await axios.patch(`/internal/license/group/${organizationId}`, request))

  export const queryOrganizationLicenseDetails = async (organizationId: string) =>
    (await axios.get<LicenseDetails>(`/internal/license/group/${organizationId}`)).data

  // Reczna rekalkulacja ("aneks"): odswieza zamrozone snapshoty cen ficzerow do biezacego
  // katalogu (feature_template.activation_cost). Log nadan (historia) nietkniety.
  export const recalculateLicense = async (organizationId: string) =>
    (await axios.post<LicenseDetails>(`/internal/license/group/${organizationId}/recalculate`)).data

  export const queryLicenseFeatureDetails = async (organizationId: string) =>
    (await axios.get<LicenseFeatureDetails[]>(`/internal/license/group/${organizationId}/features`)).data


  export type UpdateLicenseFeatureEntry = {
    featureLicenseId: string
    featureTemplateId: string
    status: string
    trialExpiredDate: string
    subscriptionType: string
    version: number
  }

  export const updateLicenseFeatureStatus = async (groupId: string, entries: UpdateLicenseFeatureEntry[]) =>
    (await axios.patch(`/internal/license/group/${groupId}/features`, {
      featureStatusList: entries
    }))


  export const queryGrantLog = async (groupId: string) =>
    (await axios.get<GrantLogEntry[]>(`/internal/license/group/${groupId}/grant-log`)).data

  export type CreateLicensePlanReq = {
    subscriptionType: string,
    featureTemplateIds: string[]
  }

  // Nadanie funkcjonalnosci licencji. Doklada nowe / przedluza istniejace na jednej licencji.
  // Cena kazdej funkcjonalnosci bierze sie z katalogu (feature_template.activation_cost) - nie z frontu.
  export const grantFeatures = async (groupId: string, req: CreateLicensePlanReq) =>
    (await axios.post(`/internal/license/group/${groupId}/grant`, req))
}
